import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faqs() {
  const { t } = useTranslation();
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { axios.get("/api/faqs").then(r => setFaqs(r.data || [])).catch(() => {}); }, []);

  const grouped = faqs.reduce((acc, f) => {
    (acc[f.categoria] = acc[f.categoria] || []).push(f);
    return acc;
  }, {});

  return (
    <section className="section-light py-12" data-testid="faqs-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="mb-8">
          <div className="divider-red mb-4"></div>
          <h1 className="font-display text-4xl sm:text-5xl">{t("faqs.titulo")}</h1>
        </div>
        {Object.entries(grouped).map(([cat, items]) => (
          <div key={cat} className="mb-8" data-testid={`faq-category-${cat.replace(/\s+/g, "-")}`}>
            <h2 className="font-display text-2xl mb-3 text-[var(--pc-red)]">■ {cat}</h2>
            <Accordion type="single" collapsible className="w-full">
              {items.map((f, i) => (
                <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${f.id}`}>
                  <AccordionTrigger className="text-left font-semibold">{f.pregunta}</AccordionTrigger>
                  <AccordionContent className="text-neutral-700">{f.respuesta}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </div>
    </section>
  );
}
